import { render, staticRenderFns } from "./SidebarMinimizer.vue?vue&type=template&id=fefb74be&"
import script from "./SidebarMinimizer.vue?vue&type=script&lang=js&"
export * from "./SidebarMinimizer.vue?vue&type=script&lang=js&"
import style0 from "./SidebarMinimizer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports